






























import Vue, { PropType } from 'vue';
import Datepicker from 'vuejs-datepicker';
import { calender } from 'mostra';
import { FirestoreDate } from '@/modules/firestore';
import moment from 'moment-timezone';

// interface DataType {
//   dateValue: Date | string | null;
//   requiredError: boolean;
// }

export default Vue.extend({
  name: 'GDatePickerEx',
  components: {
    Datepicker,
  },
  props: {
    label: { type: String as PropType<string>, default: null },
    value: { type: [Date, Object] as PropType<FirestoreDate>, default: null },
    name: { type: String as PropType<string>, required: true },
    format: { type: String as PropType<string>, default: 'yyyy/MM/dd' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRight: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => ([]) },
  },
  computed: {
    innerValue: {
      get(): string | null {
        if (this.value) {
          return calender.formatDate(this.value);
        } else {
          return null;
        }
      },
      set(val: string | null): void {
        if (!moment(val, 'YYYY/MM/DD', true).isValid()) {
          this.$emit('input', null);
        } else {
          this.$emit('input', moment(val).toDate());
        }
      },
    },
  },
});
